import {useInjection} from 'dna-react-ioc'
import {IAIChatMessengerStore, AIChatMessengerStoreSymbol} from '../IAIChatMessengerStore'

export const useAiChatMessengerStore = (): IAIChatMessengerStore => {
    return useInjection<IAIChatMessengerStore>(AIChatMessengerStoreSymbol)
}
